import { createApp } from 'vue'
import {
  Toast,
  Popup,
  Loading,
  Icon,
  Tabbar,
  TabbarItem,
  Swipe,
  SwipeItem,
  Dialog
} from 'vant'
import VueLuckyCanvas from '@lucky-canvas/vue'
import VConsole from 'vconsole'
import App from './App.vue'
import router from './router'
import 'amfe-flexible'
import 'normalize.css'

let app = createApp(App)
// 如果是测试环境，开启vconsole
if (process.env.NODE_ENV === 'development') {
  const vConsole = new VConsole()
  app = app.use(vConsole)
}

app
  .use(Toast)
  .use(Popup)
  .use(Loading)
  .use(Icon)
  .use(Tabbar)
  .use(TabbarItem)
  .use(Swipe)
  .use(SwipeItem)
  .use(Dialog)
  .use(VueLuckyCanvas)
  .use(router)
  .mount('#app')
